import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

const state = createSelector(
  (state: RootState) => state.mainPage,
  (state) => state,
);

export const selectStatus = createSelector([state], (state) => ({
  ...state.status,
  tournamentId: state.tournamentId,
}));

export const selectChampionships = createSelector([state], (state) => ({
  championships: state.championships,
  total: state.totalChampionships,
}));

export const selectTeams = createSelector([state], (state) => state.teams);
export const selectPlayers = createSelector([state], (state) => state.players);
